export const SET_FOLLOW_UP_RULE = 'FOLLOWUP/SET_FOLLOW_UP_RULE'
export const SET_FOLLOW_UP_RULES = 'FOLLOWUP/SET_FOLLOW_UP_RULES'
